import React from 'react';
import styles from './SectionSkeleton.module.css';

type Variant = 'carousel' | 'block';

interface SectionSkeletonProps {
  /** altura aproximada do miolo da seção (evita layout shift grande) */
  height?: number | string;
  /** nº de cards placeholder no modo carrossel */
  cards?: number;
  /** carrossel (linha de cards) ou bloco único */
  variant?: Variant;
  /** exibe a barra de título */
  title?: boolean;
}

const toCss = (value?: number | string): string | undefined =>
  typeof value === 'number' ? `${value}px` : value;

/**
 * Placeholder/loading genérico dos blocos lazy da home. Puramente decorativo
 * (aria-hidden) — leitores de tela ignoram; respeita prefers-reduced-motion.
 */
const SectionSkeleton: React.FC<SectionSkeletonProps> = ({
  height = 420,
  cards = 4,
  variant = 'carousel',
  title = true,
}) => {
  const innerHeight = toCss(height);

  return (
    <div className={styles.wrap} aria-hidden="true">
      <div className={styles.inner}>
        {title ? <div className={`${styles.bar} ${styles.title} ${styles.shimmer}`} /> : null}
        {variant === 'block' ? (
          <div className={`${styles.block} ${styles.shimmer}`} style={{ height: innerHeight }} />
        ) : (
          <div className={styles.row}>
            {Array.from({ length: cards }).map((_, index) => (
              <div
                key={index}
                className={`${styles.card} ${styles.shimmer}`}
                style={{ height: innerHeight }}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SectionSkeleton;
